/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type BookingClassification = "conditional" | "new_arrest" | "not_classified" | "referral" | "released" | "supervised" | "%future added value";
export type Employment = "employed" | "full_time_student" | "none" | "primary_caregiver" | "retired" | "%future added value";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type PersonSex = "female" | "male" | "unknown" | "%future added value";
export type PretrialDecision = "bailed_out" | "case_dismissed" | "or_denied" | "or_granted" | "petition_resolved" | "pretrial_release_with_conditions" | "pretrial_release_with_conditions_if_bailed_out" | "released_no_complaint_filed" | "sentenced" | "%future added value";
export type ProspectStatus = "archived" | "enroll_or_archive" | "new" | "pending_court_decision" | "pending_interview" | "pending_recommendation" | "pending_submission" | "%future added value";
export type RecommendationReviewStatus = "approved" | "not_ready_for_review" | "pending_review" | "rejected" | "%future added value";
export type ReleaseRecommendation = "deny_release" | "or_granted" | "release_with_conditions" | "%future added value";
export type SentenceDecision = "conditional_case" | "diversion" | "restitution_only" | "supervised_case" | "%future added value";
export type YesNo = "no" | "yes" | "%future added value";
export type YesNoUnknown = "no" | "unknown" | "yes" | "%future added value";
export type ZeroToThreeOrMore = "more" | "one" | "three" | "two" | "zero" | "%future added value";
export type RecommendationFormInput = {
    readonly has_verified_employment_information?: YesNo | null;
    readonly employment_comments?: string | null;
    readonly pending_disposition?: YesNo | null;
    readonly pending_disposition_comments?: string | null;
    readonly ch_misd_comments?: string | null;
    readonly fta_comments?: string | null;
    readonly vprai_override_public_safety_comments?: string | null;
    readonly incident_summary_notes?: string | null;
    readonly mandatory_detention?: YesNo | null;
    readonly additional_information?: string | null;
    readonly release_recommendation?: ReleaseRecommendation | null;
    readonly conditions_of_release: ConditionsOfReleaseInput;
    readonly reasons_against_release: ReasonsAgainstReleaseInput;
    readonly other_recommendation_notes?: string | null;
    readonly victim_comments?: string | null;
    readonly signature_probation_supervisor?: string | null;
    readonly signature_team_member?: string | null;
    readonly criminal_history?: CriminalHistoryInput | null;
    readonly afs_info: AFSInfoInput;
    readonly substance_abuse_comments?: string | null;
};
export type ConditionsOfReleaseInput = {
    readonly supervision_and_custody?: YesNo | null;
    readonly not_leave_state_or_residence?: YesNo | null;
    readonly notify_change_employment_or_residence?: YesNo | null;
    readonly report_regularly_pretrial?: YesNo | null;
    readonly report_to_probation?: YesNo | null;
    readonly tcemp?: YesNo | null;
    readonly tcv3a?: YesNo | null;
    readonly curfew?: YesNo | null;
    readonly location_tracking?: YesNo | null;
    readonly alcohol_detection?: YesNo | null;
    readonly alcohol_detection_with_curfew?: YesNo | null;
    readonly follow_court_protective_orders?: YesNo | null;
    readonly tcaap?: YesNo | null;
    readonly tcbaf?: YesNo | null;
    readonly tcnax?: YesNo | null;
    readonly tcnae?: YesNo | null;
    readonly tcgnx?: YesNo | null;
    readonly tcgwr?: YesNo | null;
    readonly follow_court_probation_conditions?: YesNo | null;
    readonly pretrial_program?: YesNo | null;
};
export type ReasonsAgainstReleaseInput = {
    readonly high_risk_to_fail_pretrial_release?: YesNo | null;
    readonly vprai_override_public_safety?: YesNo | null;
    readonly vprai_override_victim_residence?: YesNo | null;
};
export type CriminalHistoryInput = {
    readonly two_or_more_violent_convictions?: YesNo | null;
    readonly one_or_more_misdemeanor_or_felony_convictions?: YesNo | null;
    readonly no_prior_criminal_history?: YesNo | null;
};
export type AFSInfoInput = {
    readonly afs_check_date?: string | null;
    readonly number_of_weapons_registered?: number | null;
};
export type bookingsUpdateBookingRecommendationFormMutationVariables = {
    readonly booking_id: string;
    readonly recommendation_form: RecommendationFormInput;
};
export type bookingsUpdateBookingRecommendationFormMutationResponse = {
    readonly updateBookingRecommendationForm: ({
        readonly result: MutationResult;
        readonly description: string | null;
        readonly booking: ({
            readonly id: string;
            readonly booking_defendent: {
                readonly cii_number: string | null;
                readonly local_id: string | null;
                readonly cdl_id: string | null;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
                readonly date_of_birth: string;
                readonly sex: string | null;
                readonly race: string | null;
            };
            readonly booking_info: {
                readonly booking_sid: string | null;
                readonly local_id: string | null;
                readonly booking_number: string | null;
                readonly booking_datetime: string | null;
                readonly booking_address: string | null;
                readonly booking_date: string | null;
                readonly arrest_agency: string | null;
                readonly arrested_for: string | null;
            };
            readonly booking_charges: ReadonlyArray<{
                readonly id: string;
                readonly booking_charge_sid: string | null;
                readonly booking_sid: string | null;
                readonly booking_number: string;
                readonly booking_datetime: string | null;
                readonly charge_auth_type: string | null;
                readonly charge_code_section: string;
                readonly charge_type: string | null;
                readonly charge_datetime: string | null;
                readonly charge_description: string | null;
                readonly arrest_agency: string | null;
                readonly arrest_datetime: string | null;
                readonly crime_case_number: string | null;
                readonly court_warrant_number: string | null;
            }> | null;
            readonly booking_releases: ReadonlyArray<{
                readonly charge_code_section: string;
                readonly charge_description: string;
                readonly charge_type: string;
                readonly charge_release_datetime: string;
                readonly charge_release_type: string;
                readonly warrant_number: string | null;
                readonly court_case_number: string | null;
                readonly jc_control: string | null;
                readonly created_datetime: string | null;
            }> | null;
            readonly booking_status: ({
                readonly booking_number: string;
                readonly court_appearance_datetime: string;
                readonly court_reason: string | null;
                readonly court_room: string | null;
            }) | null;
            readonly classification: BookingClassification;
            readonly imported_date: string;
            readonly comments: string | null;
            readonly is_eligible: YesNoUnknown | null;
            readonly spanish_speaker: YesNoUnknown | null;
            readonly has_wait: YesNo | null;
            readonly prospect_status: ProspectStatus | null;
            readonly interview_and_assessment: ({
                readonly interview_data: ({
                    readonly residence: ({
                        readonly address: string | null;
                        readonly moved_into_current_address_date: string | null;
                        readonly phone_number: string | null;
                        readonly moved_to_bay_area_date: string | null;
                    }) | null;
                    readonly contacts: ReadonlyArray<{
                        readonly name: ({
                            readonly first: string | null;
                            readonly last: string | null;
                        }) | null;
                        readonly address: string | null;
                        readonly phone: string | null;
                        readonly date_of_birth: string | null;
                        readonly sex: PersonSex | null;
                        readonly relationship: string | null;
                        readonly how_often_seen: string | null;
                    }> | null;
                    readonly employment_and_education: ({
                        readonly is_employed: YesNo | null;
                        readonly current_employer_name: string | null;
                        readonly is_student_retired_disabled: YesNo | null;
                        readonly is_primary_caretaker: YesNo | null;
                        readonly employment_start_date: string | null;
                        readonly employment_type: string | null;
                        readonly hours_worked_per_week: number | null;
                        readonly type_of_work: string | null;
                        readonly previous_employer_name: string | null;
                        readonly previous_employer_start_date: string | null;
                        readonly previous_employer_end_date: string | null;
                        readonly unemployed_start_date: string | null;
                        readonly unemployed_how_supported: string | null;
                    }) | null;
                    readonly military_service: ({
                        readonly has_served_in_military: YesNo | null;
                        readonly military_service_comments: string | null;
                    }) | null;
                    readonly prior_record: ({
                        readonly bench_warrants_count: number | null;
                        readonly currently_on_probation: YesNo | null;
                        readonly has_pending_case: YesNo | null;
                        readonly prior_record_comments: string | null;
                    }) | null;
                    readonly substance_abuse: ({
                        readonly has_experimented_with_illegal_substances: YesNo | null;
                        readonly type_of_illegal_substance_experimented: string | null;
                        readonly last_use_of_illegal_substance_date: string | null;
                        readonly has_abused_alcohol_or_marijuana: YesNo | null;
                        readonly last_alcohol_or_marijuna_abuse_date: string | null;
                        readonly alcohol_or_marijuana_abuse_how_often: string | null;
                        readonly has_used_illegal_drugs_last_six_months: YesNo | null;
                        readonly type_of_illegal_drug_used_last_six_months: string | null;
                        readonly how_often_illegal_drug_use_last_six_months: string | null;
                        readonly has_received_treatment_alcohol_or_marijuana: YesNo | null;
                        readonly alcohol_or_marijuana_program_name: string | null;
                        readonly alcohol_or_marijuana_treatment_date: string | null;
                    }) | null;
                    readonly victim_info: ({
                        readonly was_victim_in_case: YesNo | null;
                        readonly victims: ReadonlyArray<{
                            readonly name: ({
                                readonly first: string | null;
                                readonly last: string | null;
                            }) | null;
                            readonly address: string | null;
                            readonly phone: string | null;
                            readonly date_of_birth: string | null;
                            readonly sex: PersonSex | null;
                            readonly relationship: string | null;
                            readonly how_often_seen: string | null;
                        }> | null;
                        readonly has_protective_order: YesNo | null;
                        readonly has_stay_away_order: YesNo | null;
                        readonly has_peaceful_contact_order: YesNo | null;
                        readonly protective_order_notes: string | null;
                    }) | null;
                    readonly firearm_info: ({
                        readonly has_firearm_registered: YesNo | null;
                        readonly registered_firearm_model: string | null;
                        readonly registered_firearm_location: string | null;
                        readonly has_firearm_in_home: YesNo | null;
                        readonly home_firearm_model: string | null;
                        readonly home_firearm_location: string | null;
                    }) | null;
                }) | null;
                readonly research_factors: ({
                    readonly has_prior_misdemeanor_conviction: YesNo | null;
                    readonly has_prior_felony_conviction: YesNo | null;
                    readonly prior_violent_convictions_count: ZeroToThreeOrMore | null;
                    readonly prior_FTAs_past_two_years_count: ZeroToThreeOrMore | null;
                    readonly has_prior_FTAs_older_than_two_years: YesNo | null;
                    readonly has_prior_sentence_to_incarceration: YesNo | null;
                }) | null;
                readonly risk_factors: ({
                    readonly has_active_community_supervision: YesNo | null;
                    readonly is_charge_felony_drug_theft_or_fraud: YesNo | null;
                    readonly has_pending_charges: YesNo | null;
                    readonly has_criminal_history: YesNo | null;
                    readonly has_two_or_more_FTAs: YesNo | null;
                    readonly has_two_or_more_violent_convictions: YesNo | null;
                    readonly has_history_of_drug_abuse: YesNo | null;
                    readonly employed_at_time_of_arrest: Employment | null;
                }) | null;
                readonly completed_by: ({
                    readonly id: string;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                }) | null;
                readonly court_date: string | null;
                readonly charge_bond_type_amount_court: string | null;
                readonly instrument_completed_at: string | null;
                readonly last_updated_at: string | null;
            }) | null;
            readonly is_interview_declined: YesNo | null;
            readonly court_memo: ({
                readonly was_under_the_influence_of_alcohol_or_drugs: YesNo | null;
                readonly was_combative: YesNo | null;
                readonly was_in_medical_isolation: YesNo | null;
                readonly mental_state_prevented_interview: YesNo | null;
                readonly has_refused_interview: YesNo | null;
                readonly is_no_longer_in_custody: YesNo | null;
                readonly has_declined_interview_or_release: YesNo | null;
                readonly has_plan_to_bail_out: YesNo | null;
                readonly is_incomplete_due_to_insufficient_notice: YesNo | null;
                readonly report_available_by_date: string | null;
                readonly has_existing_or_report_re_referred: YesNo | null;
                readonly existing_or_report_date: string | null;
                readonly is_incomplete_due_to_referral_volume: YesNo | null;
                readonly is_denied_or: YesNo | null;
                readonly ordered_tad_date: string | null;
                readonly has_existing_or_report_previously_interviewed: YesNo | null;
                readonly last_interviewed_date: string | null;
                readonly hold_out_state: string | null;
                readonly other_reason_comments: string | null;
                readonly signature_probation_supervisor: string | null;
                readonly signature_team_member: string | null;
            }) | null;
            readonly recommendation_form: ({
                readonly has_verified_employment_information: YesNo | null;
                readonly employment_comments: string | null;
                readonly pending_disposition: YesNo | null;
                readonly pending_disposition_comments: string | null;
                readonly ch_misd_comments: string | null;
                readonly fta_comments: string | null;
                readonly vprai_override_public_safety_comments: string | null;
                readonly signature_probation_supervisor: string | null;
                readonly signature_team_member: string | null;
                readonly incident_summary_notes: string | null;
                readonly mandatory_detention: YesNo | null;
                readonly additional_information: string | null;
                readonly release_recommendation: ReleaseRecommendation | null;
                readonly conditions_of_release: {
                    readonly supervision_and_custody: YesNo | null;
                    readonly not_leave_state_or_residence: YesNo | null;
                    readonly notify_change_employment_or_residence: YesNo | null;
                    readonly report_regularly_pretrial: YesNo | null;
                    readonly report_to_probation: YesNo | null;
                    readonly tcemp: YesNo | null;
                    readonly tcv3a: YesNo | null;
                    readonly curfew: YesNo | null;
                    readonly location_tracking: YesNo | null;
                    readonly alcohol_detection: YesNo | null;
                    readonly alcohol_detection_with_curfew: YesNo | null;
                    readonly follow_court_protective_orders: YesNo | null;
                    readonly tcaap: YesNo | null;
                    readonly tcbaf: YesNo | null;
                    readonly tcnax: YesNo | null;
                    readonly tcnae: YesNo | null;
                    readonly tcgnx: YesNo | null;
                    readonly tcgwr: YesNo | null;
                    readonly follow_court_probation_conditions: YesNo | null;
                    readonly pretrial_program: YesNo | null;
                };
                readonly reasons_against_release: {
                    readonly high_risk_to_fail_pretrial_release: YesNo | null;
                    readonly vprai_override_public_safety: YesNo | null;
                    readonly vprai_override_victim_residence: YesNo | null;
                };
                readonly criminal_history: {
                    readonly two_or_more_violent_convictions: YesNo | null;
                    readonly one_or_more_misdemeanor_or_felony_convictions: YesNo | null;
                    readonly no_prior_criminal_history: YesNo | null;
                };
                readonly substance_abuse_comments: string | null;
                readonly afs_info: {
                    readonly afs_check_date: string | null;
                    readonly number_of_weapons_registered: number | null;
                };
                readonly internal_notes: ReadonlyArray<({
                    readonly text: string;
                    readonly created_at: string;
                    readonly created_by: ({
                        readonly name: {
                            readonly first: string;
                            readonly last: string | null;
                        };
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly recommendation_review_status: RecommendationReviewStatus | null;
            readonly risk_assessment_result: ({
                readonly score: number | null;
                readonly level: string | null;
                readonly failure_rate: string | null;
            }) | null;
            readonly pretrial_decision_form: ({
                readonly decision: PretrialDecision | null;
                readonly has_gps_monitoring: YesNo | null;
                readonly has_alcohol_monitoring: YesNo | null;
                readonly has_basic_monitoring: YesNo | null;
                readonly sentencing_decision: SentenceDecision | null;
                readonly jail_sanction: YesNo | null;
            }) | null;
        }) | null;
    }) | null;
};
export type bookingsUpdateBookingRecommendationFormMutation = {
    readonly response: bookingsUpdateBookingRecommendationFormMutationResponse;
    readonly variables: bookingsUpdateBookingRecommendationFormMutationVariables;
};



/*
mutation bookingsUpdateBookingRecommendationFormMutation(
  $booking_id: ID!
  $recommendation_form: RecommendationFormInput!
) {
  updateBookingRecommendationForm(booking_id: $booking_id, recommendation_form: $recommendation_form) {
    result
    description
    booking {
      id
      booking_defendent {
        cii_number
        local_id
        cdl_id
        name {
          first
          last
        }
        date_of_birth
        sex
        race
      }
      booking_info {
        booking_sid
        local_id
        booking_number
        booking_datetime
        booking_address
        booking_date
        arrest_agency
        arrested_for
      }
      booking_charges {
        id
        booking_charge_sid
        booking_sid
        booking_number
        booking_datetime
        charge_auth_type
        charge_code_section
        charge_type
        charge_datetime
        charge_description
        arrest_agency
        arrest_datetime
        crime_case_number
        court_warrant_number
      }
      booking_releases {
        charge_code_section
        charge_description
        charge_type
        charge_release_datetime
        charge_release_type
        warrant_number
        court_case_number
        jc_control
        created_datetime
      }
      booking_status {
        booking_number
        court_appearance_datetime
        court_reason
        court_room
      }
      classification
      imported_date
      comments
      is_eligible
      spanish_speaker
      has_wait
      prospect_status
      interview_and_assessment {
        interview_data {
          residence {
            address
            moved_into_current_address_date
            phone_number
            moved_to_bay_area_date
          }
          contacts {
            name {
              first
              last
            }
            address
            phone
            date_of_birth
            sex
            relationship
            how_often_seen
          }
          employment_and_education {
            is_employed
            current_employer_name
            is_student_retired_disabled
            is_primary_caretaker
            employment_start_date
            employment_type
            hours_worked_per_week
            type_of_work
            previous_employer_name
            previous_employer_start_date
            previous_employer_end_date
            unemployed_start_date
            unemployed_how_supported
          }
          military_service {
            has_served_in_military
            military_service_comments
          }
          prior_record {
            bench_warrants_count
            currently_on_probation
            has_pending_case
            prior_record_comments
          }
          substance_abuse {
            has_experimented_with_illegal_substances
            type_of_illegal_substance_experimented
            last_use_of_illegal_substance_date
            has_abused_alcohol_or_marijuana
            last_alcohol_or_marijuna_abuse_date
            alcohol_or_marijuana_abuse_how_often
            has_used_illegal_drugs_last_six_months
            type_of_illegal_drug_used_last_six_months
            how_often_illegal_drug_use_last_six_months
            has_received_treatment_alcohol_or_marijuana
            alcohol_or_marijuana_program_name
            alcohol_or_marijuana_treatment_date
          }
          victim_info {
            was_victim_in_case
            victims {
              name {
                first
                last
              }
              address
              phone
              date_of_birth
              sex
              relationship
              how_often_seen
            }
            has_protective_order
            has_stay_away_order
            has_peaceful_contact_order
            protective_order_notes
          }
          firearm_info {
            has_firearm_registered
            registered_firearm_model
            registered_firearm_location
            has_firearm_in_home
            home_firearm_model
            home_firearm_location
          }
        }
        research_factors {
          has_prior_misdemeanor_conviction
          has_prior_felony_conviction
          prior_violent_convictions_count
          prior_FTAs_past_two_years_count
          has_prior_FTAs_older_than_two_years
          has_prior_sentence_to_incarceration
        }
        risk_factors {
          has_active_community_supervision
          is_charge_felony_drug_theft_or_fraud
          has_pending_charges
          has_criminal_history
          has_two_or_more_FTAs
          has_two_or_more_violent_convictions
          has_history_of_drug_abuse
          employed_at_time_of_arrest
        }
        completed_by {
          id
          name {
            first
            last
          }
        }
        court_date
        charge_bond_type_amount_court
        instrument_completed_at
        last_updated_at
      }
      is_interview_declined
      court_memo {
        was_under_the_influence_of_alcohol_or_drugs
        was_combative
        was_in_medical_isolation
        mental_state_prevented_interview
        has_refused_interview
        is_no_longer_in_custody
        has_declined_interview_or_release
        has_plan_to_bail_out
        is_incomplete_due_to_insufficient_notice
        report_available_by_date
        has_existing_or_report_re_referred
        existing_or_report_date
        is_incomplete_due_to_referral_volume
        is_denied_or
        ordered_tad_date
        has_existing_or_report_previously_interviewed
        last_interviewed_date
        hold_out_state
        other_reason_comments
        signature_probation_supervisor
        signature_team_member
      }
      recommendation_form {
        has_verified_employment_information
        employment_comments
        pending_disposition
        pending_disposition_comments
        ch_misd_comments
        fta_comments
        vprai_override_public_safety_comments
        signature_probation_supervisor
        signature_team_member
        incident_summary_notes
        mandatory_detention
        additional_information
        release_recommendation
        conditions_of_release {
          supervision_and_custody
          not_leave_state_or_residence
          notify_change_employment_or_residence
          report_regularly_pretrial
          report_to_probation
          tcemp
          tcv3a
          curfew
          location_tracking
          alcohol_detection
          alcohol_detection_with_curfew
          follow_court_protective_orders
          tcaap
          tcbaf
          tcnax
          tcnae
          tcgnx
          tcgwr
          follow_court_probation_conditions
          pretrial_program
        }
        reasons_against_release {
          high_risk_to_fail_pretrial_release
          vprai_override_public_safety
          vprai_override_victim_residence
        }
        criminal_history {
          two_or_more_violent_convictions
          one_or_more_misdemeanor_or_felony_convictions
          no_prior_criminal_history
        }
        substance_abuse_comments
        afs_info {
          afs_check_date
          number_of_weapons_registered
        }
        internal_notes {
          text
          created_at
          created_by {
            name {
              first
              last
            }
            id
          }
        }
      }
      recommendation_review_status
      risk_assessment_result {
        score
        level
        failure_rate
      }
      pretrial_decision_form {
        decision
        has_gps_monitoring
        has_alcohol_monitoring
        has_basic_monitoring
        sentencing_decision
        jail_sanction
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "booking_id",
            "type": "ID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "recommendation_form",
            "type": "RecommendationFormInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "booking_id",
            "variableName": "booking_id"
        } as any),
        ({
            "kind": "Variable",
            "name": "recommendation_form",
            "variableName": "recommendation_form"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "result",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "local_id",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "first",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "last",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": (v6 /*: any*/)
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "date_of_birth",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sex",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_defendent",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingDefendent",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "cii_number",
                "args": null,
                "storageKey": null
            },
            (v5 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "cdl_id",
                "args": null,
                "storageKey": null
            },
            (v7 /*: any*/),
            (v8 /*: any*/),
            (v9 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "race",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_sid",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_number",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_datetime",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "arrest_agency",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_info",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingInfo",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            (v5 /*: any*/),
            (v12 /*: any*/),
            (v13 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_address",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_date",
                "args": null,
                "storageKey": null
            },
            (v14 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "arrested_for",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_code_section",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_type",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_description",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_charges",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingCharge",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_charge_sid",
                "args": null,
                "storageKey": null
            },
            (v11 /*: any*/),
            (v12 /*: any*/),
            (v13 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_auth_type",
                "args": null,
                "storageKey": null
            },
            (v16 /*: any*/),
            (v17 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_datetime",
                "args": null,
                "storageKey": null
            },
            (v18 /*: any*/),
            (v14 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "arrest_datetime",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "crime_case_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_warrant_number",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_releases",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingRelease",
        "plural": true,
        "selections": [
            (v16 /*: any*/),
            (v18 /*: any*/),
            (v17 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_release_datetime",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_release_type",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "warrant_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_case_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jc_control",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "created_datetime",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v21 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_status",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingStatus",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_appearance_datetime",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_reason",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_room",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "classification",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "imported_date",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "comments",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is_eligible",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "spanish_speaker",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "has_wait",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "prospect_status",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "address",
        "args": null,
        "storageKey": null
    } as any), v30 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "name",
            "storageKey": null,
            "args": null,
            "concreteType": "VictimName",
            "plural": false,
            "selections": (v6 /*: any*/)
        } as any),
        (v29 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
        } as any),
        (v8 /*: any*/),
        (v9 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "relationship",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "how_often_seen",
            "args": null,
            "storageKey": null
        } as any)
    ], v31 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "interview_and_assessment",
        "storageKey": null,
        "args": null,
        "concreteType": "InterviewAndAssessment",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "interview_data",
                "storageKey": null,
                "args": null,
                "concreteType": "InterviewData",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "residence",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResidenceInfo",
                        "plural": false,
                        "selections": [
                            (v29 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "moved_into_current_address_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "phone_number",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "moved_to_bay_area_date",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contacts",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ParticipantContact",
                        "plural": true,
                        "selections": (v30 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "employment_and_education",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EmploymentAndEducationInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "is_employed",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "current_employer_name",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "is_student_retired_disabled",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "is_primary_caretaker",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "employment_start_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "employment_type",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hours_worked_per_week",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type_of_work",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "previous_employer_name",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "previous_employer_start_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "previous_employer_end_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "unemployed_start_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "unemployed_how_supported",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "military_service",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MilitaryServiceInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_served_in_military",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "military_service_comments",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "prior_record",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PriorRecordInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "bench_warrants_count",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "currently_on_probation",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_pending_case",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "prior_record_comments",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "substance_abuse",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SubstanceAbuseInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_experimented_with_illegal_substances",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type_of_illegal_substance_experimented",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "last_use_of_illegal_substance_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_abused_alcohol_or_marijuana",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "last_alcohol_or_marijuna_abuse_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "alcohol_or_marijuana_abuse_how_often",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_used_illegal_drugs_last_six_months",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type_of_illegal_drug_used_last_six_months",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "how_often_illegal_drug_use_last_six_months",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_received_treatment_alcohol_or_marijuana",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "alcohol_or_marijuana_program_name",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "alcohol_or_marijuana_treatment_date",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "victim_info",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VictimInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "was_victim_in_case",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "victims",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ParticipantContact",
                                "plural": true,
                                "selections": (v30 /*: any*/)
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_protective_order",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_stay_away_order",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_peaceful_contact_order",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "protective_order_notes",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "firearm_info",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FirearmInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_firearm_registered",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "registered_firearm_model",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "registered_firearm_location",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "has_firearm_in_home",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "home_firearm_model",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "home_firearm_location",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "research_factors",
                "storageKey": null,
                "args": null,
                "concreteType": "ResearchFactor",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_prior_misdemeanor_conviction",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_prior_felony_conviction",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "prior_violent_convictions_count",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "prior_FTAs_past_two_years_count",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_prior_FTAs_older_than_two_years",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_prior_sentence_to_incarceration",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "risk_factors",
                "storageKey": null,
                "args": null,
                "concreteType": "RiskFactor",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_active_community_supervision",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_charge_felony_drug_theft_or_fraud",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_pending_charges",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_criminal_history",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_two_or_more_FTAs",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_two_or_more_violent_convictions",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "has_history_of_drug_abuse",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "employed_at_time_of_arrest",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "completed_by",
                "storageKey": null,
                "args": null,
                "concreteType": "CaseManager",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v7 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_bond_type_amount_court",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "instrument_completed_at",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_updated_at",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is_interview_declined",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "signature_probation_supervisor",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "signature_team_member",
        "args": null,
        "storageKey": null
    } as any), v35 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "court_memo",
        "storageKey": null,
        "args": null,
        "concreteType": "CourtMemo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "was_under_the_influence_of_alcohol_or_drugs",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "was_combative",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "was_in_medical_isolation",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "mental_state_prevented_interview",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_refused_interview",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_no_longer_in_custody",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_declined_interview_or_release",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_plan_to_bail_out",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_incomplete_due_to_insufficient_notice",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "report_available_by_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_existing_or_report_re_referred",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "existing_or_report_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_incomplete_due_to_referral_volume",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_denied_or",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "ordered_tad_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_existing_or_report_previously_interviewed",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_interviewed_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hold_out_state",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "other_reason_comments",
                "args": null,
                "storageKey": null
            },
            (v33 /*: any*/),
            (v34 /*: any*/)
        ]
    } as any), v36 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "has_verified_employment_information",
        "args": null,
        "storageKey": null
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "employment_comments",
        "args": null,
        "storageKey": null
    } as any), v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pending_disposition",
        "args": null,
        "storageKey": null
    } as any), v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pending_disposition_comments",
        "args": null,
        "storageKey": null
    } as any), v40 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ch_misd_comments",
        "args": null,
        "storageKey": null
    } as any), v41 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "fta_comments",
        "args": null,
        "storageKey": null
    } as any), v42 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vprai_override_public_safety_comments",
        "args": null,
        "storageKey": null
    } as any), v43 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "incident_summary_notes",
        "args": null,
        "storageKey": null
    } as any), v44 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "mandatory_detention",
        "args": null,
        "storageKey": null
    } as any), v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "additional_information",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "release_recommendation",
        "args": null,
        "storageKey": null
    } as any), v47 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "conditions_of_release",
        "storageKey": null,
        "args": null,
        "concreteType": "ConditionsOfRelease",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "supervision_and_custody",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "not_leave_state_or_residence",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "notify_change_employment_or_residence",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "report_regularly_pretrial",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "report_to_probation",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcemp",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcv3a",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "curfew",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "location_tracking",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "alcohol_detection",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "alcohol_detection_with_curfew",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "follow_court_protective_orders",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcaap",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcbaf",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcnax",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcnae",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcgnx",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "tcgwr",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "follow_court_probation_conditions",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "pretrial_program",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v48 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "reasons_against_release",
        "storageKey": null,
        "args": null,
        "concreteType": "ReasonsAgainstRelease",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "high_risk_to_fail_pretrial_release",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vprai_override_public_safety",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vprai_override_victim_residence",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v49 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "criminal_history",
        "storageKey": null,
        "args": null,
        "concreteType": "CriminalHistory",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "two_or_more_violent_convictions",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "one_or_more_misdemeanor_or_felony_convictions",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "no_prior_criminal_history",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v50 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "substance_abuse_comments",
        "args": null,
        "storageKey": null
    } as any), v51 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "afs_info",
        "storageKey": null,
        "args": null,
        "concreteType": "AFSInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "afs_check_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_weapons_registered",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v52 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "text",
        "args": null,
        "storageKey": null
    } as any), v53 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "created_at",
        "args": null,
        "storageKey": null
    } as any), v54 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "recommendation_review_status",
        "args": null,
        "storageKey": null
    } as any), v55 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "risk_assessment_result",
        "storageKey": null,
        "args": null,
        "concreteType": "RiskAssessmentResult",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "score",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "level",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "failure_rate",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v56 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pretrial_decision_form",
        "storageKey": null,
        "args": null,
        "concreteType": "PretrialDecisionForm",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "decision",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_gps_monitoring",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_alcohol_monitoring",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "has_basic_monitoring",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "sentencing_decision",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jail_sanction",
                "args": null,
                "storageKey": null
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "bookingsUpdateBookingRecommendationFormMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "updateBookingRecommendationForm",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "NewBookingResult",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Booking",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v10 /*: any*/),
                                (v15 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v24 /*: any*/),
                                (v25 /*: any*/),
                                (v26 /*: any*/),
                                (v27 /*: any*/),
                                (v28 /*: any*/),
                                (v31 /*: any*/),
                                (v32 /*: any*/),
                                (v35 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "recommendation_form",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RecommendationForm",
                                    "plural": false,
                                    "selections": [
                                        (v36 /*: any*/),
                                        (v37 /*: any*/),
                                        (v38 /*: any*/),
                                        (v39 /*: any*/),
                                        (v40 /*: any*/),
                                        (v41 /*: any*/),
                                        (v42 /*: any*/),
                                        (v33 /*: any*/),
                                        (v34 /*: any*/),
                                        (v43 /*: any*/),
                                        (v44 /*: any*/),
                                        (v45 /*: any*/),
                                        (v46 /*: any*/),
                                        (v47 /*: any*/),
                                        (v48 /*: any*/),
                                        (v49 /*: any*/),
                                        (v50 /*: any*/),
                                        (v51 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "internal_notes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ProspectNote",
                                            "plural": true,
                                            "selections": [
                                                (v52 /*: any*/),
                                                (v53 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "created_by",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CaseManager",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v54 /*: any*/),
                                (v55 /*: any*/),
                                (v56 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "bookingsUpdateBookingRecommendationFormMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "updateBookingRecommendationForm",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "NewBookingResult",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Booking",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v10 /*: any*/),
                                (v15 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v24 /*: any*/),
                                (v25 /*: any*/),
                                (v26 /*: any*/),
                                (v27 /*: any*/),
                                (v28 /*: any*/),
                                (v31 /*: any*/),
                                (v32 /*: any*/),
                                (v35 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "recommendation_form",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RecommendationForm",
                                    "plural": false,
                                    "selections": [
                                        (v36 /*: any*/),
                                        (v37 /*: any*/),
                                        (v38 /*: any*/),
                                        (v39 /*: any*/),
                                        (v40 /*: any*/),
                                        (v41 /*: any*/),
                                        (v42 /*: any*/),
                                        (v33 /*: any*/),
                                        (v34 /*: any*/),
                                        (v43 /*: any*/),
                                        (v44 /*: any*/),
                                        (v45 /*: any*/),
                                        (v46 /*: any*/),
                                        (v47 /*: any*/),
                                        (v48 /*: any*/),
                                        (v49 /*: any*/),
                                        (v50 /*: any*/),
                                        (v51 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "internal_notes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ProspectNote",
                                            "plural": true,
                                            "selections": [
                                                (v52 /*: any*/),
                                                (v53 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "created_by",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CaseManager",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v54 /*: any*/),
                                (v55 /*: any*/),
                                (v56 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "bookingsUpdateBookingRecommendationFormMutation",
            "id": null,
            "text": "mutation bookingsUpdateBookingRecommendationFormMutation(\n  $booking_id: ID!\n  $recommendation_form: RecommendationFormInput!\n) {\n  updateBookingRecommendationForm(booking_id: $booking_id, recommendation_form: $recommendation_form) {\n    result\n    description\n    booking {\n      id\n      booking_defendent {\n        cii_number\n        local_id\n        cdl_id\n        name {\n          first\n          last\n        }\n        date_of_birth\n        sex\n        race\n      }\n      booking_info {\n        booking_sid\n        local_id\n        booking_number\n        booking_datetime\n        booking_address\n        booking_date\n        arrest_agency\n        arrested_for\n      }\n      booking_charges {\n        id\n        booking_charge_sid\n        booking_sid\n        booking_number\n        booking_datetime\n        charge_auth_type\n        charge_code_section\n        charge_type\n        charge_datetime\n        charge_description\n        arrest_agency\n        arrest_datetime\n        crime_case_number\n        court_warrant_number\n      }\n      booking_releases {\n        charge_code_section\n        charge_description\n        charge_type\n        charge_release_datetime\n        charge_release_type\n        warrant_number\n        court_case_number\n        jc_control\n        created_datetime\n      }\n      booking_status {\n        booking_number\n        court_appearance_datetime\n        court_reason\n        court_room\n      }\n      classification\n      imported_date\n      comments\n      is_eligible\n      spanish_speaker\n      has_wait\n      prospect_status\n      interview_and_assessment {\n        interview_data {\n          residence {\n            address\n            moved_into_current_address_date\n            phone_number\n            moved_to_bay_area_date\n          }\n          contacts {\n            name {\n              first\n              last\n            }\n            address\n            phone\n            date_of_birth\n            sex\n            relationship\n            how_often_seen\n          }\n          employment_and_education {\n            is_employed\n            current_employer_name\n            is_student_retired_disabled\n            is_primary_caretaker\n            employment_start_date\n            employment_type\n            hours_worked_per_week\n            type_of_work\n            previous_employer_name\n            previous_employer_start_date\n            previous_employer_end_date\n            unemployed_start_date\n            unemployed_how_supported\n          }\n          military_service {\n            has_served_in_military\n            military_service_comments\n          }\n          prior_record {\n            bench_warrants_count\n            currently_on_probation\n            has_pending_case\n            prior_record_comments\n          }\n          substance_abuse {\n            has_experimented_with_illegal_substances\n            type_of_illegal_substance_experimented\n            last_use_of_illegal_substance_date\n            has_abused_alcohol_or_marijuana\n            last_alcohol_or_marijuna_abuse_date\n            alcohol_or_marijuana_abuse_how_often\n            has_used_illegal_drugs_last_six_months\n            type_of_illegal_drug_used_last_six_months\n            how_often_illegal_drug_use_last_six_months\n            has_received_treatment_alcohol_or_marijuana\n            alcohol_or_marijuana_program_name\n            alcohol_or_marijuana_treatment_date\n          }\n          victim_info {\n            was_victim_in_case\n            victims {\n              name {\n                first\n                last\n              }\n              address\n              phone\n              date_of_birth\n              sex\n              relationship\n              how_often_seen\n            }\n            has_protective_order\n            has_stay_away_order\n            has_peaceful_contact_order\n            protective_order_notes\n          }\n          firearm_info {\n            has_firearm_registered\n            registered_firearm_model\n            registered_firearm_location\n            has_firearm_in_home\n            home_firearm_model\n            home_firearm_location\n          }\n        }\n        research_factors {\n          has_prior_misdemeanor_conviction\n          has_prior_felony_conviction\n          prior_violent_convictions_count\n          prior_FTAs_past_two_years_count\n          has_prior_FTAs_older_than_two_years\n          has_prior_sentence_to_incarceration\n        }\n        risk_factors {\n          has_active_community_supervision\n          is_charge_felony_drug_theft_or_fraud\n          has_pending_charges\n          has_criminal_history\n          has_two_or_more_FTAs\n          has_two_or_more_violent_convictions\n          has_history_of_drug_abuse\n          employed_at_time_of_arrest\n        }\n        completed_by {\n          id\n          name {\n            first\n            last\n          }\n        }\n        court_date\n        charge_bond_type_amount_court\n        instrument_completed_at\n        last_updated_at\n      }\n      is_interview_declined\n      court_memo {\n        was_under_the_influence_of_alcohol_or_drugs\n        was_combative\n        was_in_medical_isolation\n        mental_state_prevented_interview\n        has_refused_interview\n        is_no_longer_in_custody\n        has_declined_interview_or_release\n        has_plan_to_bail_out\n        is_incomplete_due_to_insufficient_notice\n        report_available_by_date\n        has_existing_or_report_re_referred\n        existing_or_report_date\n        is_incomplete_due_to_referral_volume\n        is_denied_or\n        ordered_tad_date\n        has_existing_or_report_previously_interviewed\n        last_interviewed_date\n        hold_out_state\n        other_reason_comments\n        signature_probation_supervisor\n        signature_team_member\n      }\n      recommendation_form {\n        has_verified_employment_information\n        employment_comments\n        pending_disposition\n        pending_disposition_comments\n        ch_misd_comments\n        fta_comments\n        vprai_override_public_safety_comments\n        signature_probation_supervisor\n        signature_team_member\n        incident_summary_notes\n        mandatory_detention\n        additional_information\n        release_recommendation\n        conditions_of_release {\n          supervision_and_custody\n          not_leave_state_or_residence\n          notify_change_employment_or_residence\n          report_regularly_pretrial\n          report_to_probation\n          tcemp\n          tcv3a\n          curfew\n          location_tracking\n          alcohol_detection\n          alcohol_detection_with_curfew\n          follow_court_protective_orders\n          tcaap\n          tcbaf\n          tcnax\n          tcnae\n          tcgnx\n          tcgwr\n          follow_court_probation_conditions\n          pretrial_program\n        }\n        reasons_against_release {\n          high_risk_to_fail_pretrial_release\n          vprai_override_public_safety\n          vprai_override_victim_residence\n        }\n        criminal_history {\n          two_or_more_violent_convictions\n          one_or_more_misdemeanor_or_felony_convictions\n          no_prior_criminal_history\n        }\n        substance_abuse_comments\n        afs_info {\n          afs_check_date\n          number_of_weapons_registered\n        }\n        internal_notes {\n          text\n          created_at\n          created_by {\n            name {\n              first\n              last\n            }\n            id\n          }\n        }\n      }\n      recommendation_review_status\n      risk_assessment_result {\n        score\n        level\n        failure_rate\n      }\n      pretrial_decision_form {\n        decision\n        has_gps_monitoring\n        has_alcohol_monitoring\n        has_basic_monitoring\n        sentencing_decision\n        jail_sanction\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'dcf580134ae0e9293c7fd4839411d2a8';
export default node;
